import type { FaireBrandEntity } from "../../entity_types/brand";

export const catalog_brand_roen: FaireBrandEntity = {
  token: "catalog_brand_roen",
  type: "brand",
  name: "ROEN",
  avatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/3da3fd0a6388e910dd8ba747aee165a405e3debec0646a2d6a0574aa7e928afd.webp",
  location: "Los Angeles, CA",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/3da3fd0a6388e910dd8ba747aee165a405e3debec0646a2d6a0574aa7e928afd.webp",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 106,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
